import request from "@/utils/request";

// 获取支付列表
export function getPayOrderList(data) {
  return request({
      url: "/admin/base/payOrderList",
      method: "get",
      params: data
  });
}